import { MedicalServices } from "@mui/icons-material";
import { IFeatures } from "@/utils/interfaces";
import { useSessionContext } from "@/contexts/SessionContext";
import { useViewContext } from "@/contexts/ViewContext";
import { useProntoAtendimentoContractContext } from "@/contexts/ProntoAtendimentoContractContext";
import { ProntoAtendimentoPage } from "./ProntoAtendimentoPage";

export function useProntoAtendimento() {
  const { access } = useSessionContext();
  const { availableRoles } = useViewContext();
  const { contractProntoAtendimento } = useProntoAtendimentoContractContext();

  const isPractitioner = availableRoles?.includes("practitioner");
  const canClinic =
    availableRoles?.includes("manager") ||
    availableRoles?.includes("owner") ||
    availableRoles?.includes("associated");

  const configs: IFeatures = {
    active:
      access.type === "professional" &&
      Boolean(contractProntoAtendimento) &&
      (Boolean(isPractitioner) || Boolean(canClinic)),
    path: "/prontoatendimento",
    icon: MedicalServices,
    text: "Pronto Atendimento",
    sideMenu: true,
    sideMenuIndex: 0,
    component: () => <ProntoAtendimentoPage />,
  };

  return configs;
}
